import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Returns {subscription, per_quote_credits, daysLeft, expiringSoon, loading} */
export function useBilling() {
  const [data, setData] = useState({ subscription: null, per_quote_credits: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/payments/me")
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const sub = data.subscription;
  let daysLeft = null;
  if (sub?.expires_at) {
    const ms = new Date(sub.expires_at).getTime() - Date.now();
    daysLeft = Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
  }
  const expiringSoon = sub?.status === "active" && daysLeft !== null && daysLeft <= 3;

  return { ...data, daysLeft, expiringSoon, loading };
}
